export default __webpack_public_path__ + "static/media/sub-topic-model-04.54eda1de.glb";